module.exports = __webpack_public_path__ + "img/icon_digital_share.36326c53.png";